import React from 'react';
import { Box, Typography, Card, CardMedia, CardContent, IconButton, Modal } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useState, useEffect } from 'react';
import ProductDetails from '../Product/Body/ProductDetails';

// Sample staff picks data
const STAFF_PICKS = [
  {
    id: 'staff-1',
    images: [
      "https://cdn.shopify.com/s/files/1/0733/5526/4288/files/DSC089103_1.jpg?v=1710615456",
      "https://cdn.shopify.com/s/files/1/0733/5526/4288/files/kalkidan_fixed.png?v=1710615456",
      "https://cdn.shopify.com/s/files/1/0733/5526/4288/files/bobbypost-letter.jpg?v=1710615456"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/0733/5526/4288/files/bobbypost-letter.jpg?v=1710615456",
    brand: "Kidan Clothing",
    title: "HIS PROMISES CREWNECK",
    price: "25.00",
    originalPrice: null,
    productType: "Crewneck",
    link: "https://kidanclothing.com/products/his-promises-crew-neck"
  },
  {
    id: 'staff-2',
    images: [
      "https://cdn.shopify.com/s/files/1/2874/4636/files/Psalm_23_Jersey_front.jpg?v=1749728594",
      "https://cdn.shopify.com/s/files/1/2874/4636/files/228A6092.jpg?v=1749728594",
      "https://cdn.shopify.com/s/files/1/2874/4636/files/228A6142.jpg?v=1749728594",
      "https://cdn.shopify.com/s/files/1/2874/4636/files/228A6344.jpg?v=1749728594",
      "https://cdn.shopify.com/s/files/1/2874/4636/files/228A6111-2.jpg?v=1749728594",
      "https://cdn.shopify.com/s/files/1/2874/4636/files/228A61212.jpg?v=1749728594",
      "https://cdn.shopify.com/s/files/1/2874/4636/files/228A6340.jpg?v=1749728594",
      "https://cdn.shopify.com/s/files/1/2874/4636/files/228A6345.jpg?v=1749728588",
      "https://cdn.shopify.com/s/files/1/2874/4636/files/psalm_back.jpg?v=1749728588"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/2874/4636/files/Psalm_23_Jersey_front.jpg?v=1749728594",
    brand: "Red Letter Clothing",
    title: "Psalm 23 Jersey",
    price: "48.00",
    originalPrice: null,
    productType: "T-shirt",
    link: "https://redletterclo.com/products/psalm-23-jersey"
  },
  {
    id: 'staff-3',
   images: [
      "https://cdn.shopify.com/s/files/1/2468/1631/files/BB144FA3-A810-4CAB-8A6C-642650859924.png?v=1759860071"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/2468/1631/files/BB144FA3-A810-4CAB-8A6C-642650859924.png?v=1759860071",
    brand: "IV His Glory",
    title: "Led By The Spirit",
    price: "28.00",
    originalPrice: null,
    productType: "Others",
    link: "https://ivhisglory.com/products/led-by-the-spirit"
  },
  {
    id: 'staff-4',
    "images": [
      "https://cdn.shopify.com/s/files/1/0711/5590/8881/files/image_51956364-f73d-486d-9967-18a5393d8746.heic?v=1684787963",
      "https://cdn.shopify.com/s/files/1/0711/5590/8881/files/image_2eb5c5c8-e1e3-44aa-a771-f5a86209a1fe.heic?v=1684787963"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/0711/5590/8881/files/image_51956364-f73d-486d-9967-18a5393d8746.heic?v=1684787963",
    brand: "His Glory Shop",
    title: "Brown Carry Your Cross hoodie",
    price: "65.00",
    originalPrice: "65.00",
    productType: "Hoodie",
    link: "https://hisglory.shop/products/carry-your-cross-hoodie-1"
  },
  {
    id: 'staff-5',
    images: [
      "https://cdn.shopify.com/s/files/1/0733/5526/4288/files/samir_a0b08343-71c6-4d57-a27b-95ebf3cc7864.jpg?v=1710615398",
      "https://cdn.shopify.com/s/files/1/0733/5526/4288/files/DSC089642.jpg?v=1710615397"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/0733/5526/4288/files/samir_a0b08343-71c6-4d57-a27b-95ebf3cc7864.jpg?v=1710615398",
    brand: "Kidan Clothing",
    title: "HIS PROMISES SHORT SLEEVE",
    price: "15.00",
    originalPrice: null,
    productType: "T-shirt",
    link: "https://kidanclothing.com/products/his-promises-short-sleeve"
  }
];

export default function StaffPicks() {
  return (
    <Box sx={{ mx: 1.5,}}>
      {/* Section Title */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          mb: 2,
          px: 1,
          textAlign: 'left',
          color: '#333'
        }}
      >
        Staff Picks
      </Typography>

      {/* Horizontal Scrollable Container */}
      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 2,
          pb: 2,
          scrollbarWidth: 'none', // Hide scrollbar for Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // Hide scrollbar for Webkit browsers
          },
        }}
      >
        {STAFF_PICKS.map((product) => (
          <StaffPickCard key={product.id} product={product} />
        ))}
      </Box>
    </Box>
  );
}

// Individual staff pick card component
function StaffPickCard({ product }) {
  const { imageUrl, discount, brand, title, price, originalPrice } = product;
  const [liked, setLiked] = useState(false);
  const [open, setOpen] = useState(false); // State to track if the modal is open

  // Check localStorage for liked state on component mount
  useEffect(() => {
    const likedItems = JSON.parse(localStorage.getItem('likedItems')) || [];
    const alreadyLiked = likedItems.some(item => item.title === title);
    setLiked(alreadyLiked);
  }, [title]);

  const handleLike = (e) => {
    e.stopPropagation();
    const likedItems = JSON.parse(localStorage.getItem('likedItems')) || [];

    if (liked) {
      // Remove from liked
      const updatedLikedItems = likedItems.filter(
        (item) => item.id !== product.id && item.title !== product.title
      );
      localStorage.setItem('likedItems', JSON.stringify(updatedLikedItems));
      setLiked(false);
    } else {
      // Add to liked if not already present
      const alreadyExists = likedItems.some(
        (item) => item.id === product.id || item.title === product.title
      );
      if (!alreadyExists) {
        likedItems.push(product);
        localStorage.setItem('likedItems', JSON.stringify(likedItems));
      }
      setLiked(true);
    }
  };

  return (
    <>
    <Card
      onClick={() => setOpen(true)} // Open modal on click
      sx={{
        minWidth: 200,
        maxWidth: 200,
        height: 275,
        cursor: 'pointer',
        position: 'relative',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        borderRadius: 2,
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
        },
        textAlign: 'left',
      }}
    >
            {/* Discount Badge */}
      {/* {discount && (
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            left: 8,
            backgroundColor: 'rgba(141, 140, 140, 0.8)',
            color: 'white',
            borderRadius: 1,
            px: 1,
            py: 0.5,
            fontSize: '0.7rem',
            fontWeight: 'bold',
            zIndex: 1,
          }}
        >
          {discount}% off
        </Box>
      )} */}

      {/* Like Button */}
      {/* <IconButton
        onClick={handleLike}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          }
        }}
        size="small"
      >
        {liked ? (
          <FavoriteIcon sx={{ fontSize: 16, color: 'red' }} />
        ) : (
          <FavoriteBorderIcon sx={{ fontSize: 16, color: 'white' }} />
        )}
      </IconButton> */}

      {/* Product Image */}
      <CardMedia
        component="img"
        image={imageUrl}
        alt={title}
        sx={{
          height: 180,
          objectFit: 'cover',
        }}
      />

      {/* Product Details */}
      <CardContent sx={{ pt: 1.5, mb: 0 }}>
        <Typography
          sx={{
            color: 'gray',
            fontWeight: 'bold',
            fontSize: '0.7rem',
            mb: 1,
            textAlign: 'left',
          }}
        >
          {brand}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.9rem',
            lineHeight: 1.2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            mt: 1,
          }}
        >
          {title.length > 17 ? `${title.substring(0, 17)}...` : title}
        </Typography>

        {/* Price and Like Button */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            ${price}
          </Typography>
          {/* {originalPrice && originalPrice !== price && (
            <Typography
              variant="caption"
              sx={{
                textDecoration: 'line-through',
                color: 'gray',
                fontSize: '0.7rem',
              }}
            >
              ${originalPrice}
            </Typography>
          )} */}
          <IconButton
            onClick={handleLike}
            sx={{
              padding: 0.5,
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              zIndex: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              }
            }}
            size="small"
          >
            {liked ? (
              <FavoriteIcon sx={{ fontSize: 16, color: 'red' }} />
            ) : (
              <FavoriteBorderIcon sx={{ fontSize: 16, color: 'gray' }} />
            )}
          </IconButton>
        </Box>
      </CardContent>
          {/* Product Details Modal */}
    <Modal open={open} onClose={() => setOpen(false)} disableScrollLock={false}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          outline: 'none',
          width: '80%',
          maxHeight: '95vh',
          overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <ProductDetails
          product={product}
          onClose={() => setOpen(false)}
          onLikeChange={() => {
            // Refresh liked state when modal closes
            const likedItems = JSON.parse(localStorage.getItem('likedItems')) || [];
            const alreadyLiked = likedItems.some(item => item.title === title);
            setLiked(alreadyLiked);
          }}
        />
      </Box>
    </Modal>
    </Card>


    </>
    
  );
}